const templateInitialState = {
	title: null,
	priority: null,
	celebration: false,
	generateDocument: false,
	updateData: false,
	users: [],
	teams: [],
	sendReferrer: false
};

const initialState = {
	notificationType: null,
	redirectTo: null,
	notificationsInitialState: {
		updateEvery: {
			selected: false,
			value: null,
			intervalType: null
		},

		ifValueIs: {
			selected: false,
			value: null,
			option: null
		},

		whenUpdated: {
			selected: false
		},

		lastDaysAverage: {
			selected: false,
			lastDaysValue: null,
			option: null,
			value: null
		},

		valueEquals: {
			selected: false,
			value: null,
			timesValue: null,
			daysValue: null
		},

		useTemplate: false,
		template: { ...templateInitialState }
	}
};

export default {
	namespaced: true,

	//#region [ State ]
	state: {
		...initialState
	},
	//#endregion

	//#region [ Mutations ]
	mutations: {
		setNotificationType(state, payload) {
			state.notificationType = payload;
		},

		setRedirectTo(state, payload) {
			state.redirectTo = payload;
		},

		reset(state) {
			Object.assign(state, initialState);
		}
	},
	//#endregion

	//#region [ Actions ]
	actions: {
		setNotificationTypeState({ commit }, value) {
			commit('setNotificationType', value);
		},

		setRedirectTo({ commit }, value) {
			commit('setRedirectTo', value);
		},

		resetState({ commit }) {
			commit('reset');
		}
	},
	//#endregion

	//#region [ Getters ]
	getters: {}
	//#endregion
};
